import React from 'react';

interface FiltrosPessoasProps {
  filtros: {
    nome: string;
    email: string;
    telefone: string;
    vinculo: string;
    status: 'ATIVOS' | 'INATIVOS' | 'TODOS';
  };
  onFiltroChange: (campo: string, valor: string) => void;
}

const FiltrosPessoas: React.FC<FiltrosPessoasProps> = ({ filtros, onFiltroChange }) => {
  return (
    <div className="filtros-container">
      <div className="filtros-grid">
        <div className="form-group">
          <label>Nome</label>
          <input 
            type="text" 
            className="form-control" 
            value={filtros.nome} 
            onChange={(e) => onFiltroChange('nome', e.target.value)} 
            placeholder="Digite o nome" 
          />
        </div>
        <div className="form-group">
          <label>Email</label>
          <input 
            type="text" 
            className="form-control" 
            value={filtros.email} 
            onChange={(e) => onFiltroChange('email', e.target.value)} 
            placeholder="Digite o email" 
          />
        </div>
        <div className="form-group">
          <label>Telefone</label>
          <input 
            type="text" 
            className="form-control" 
            value={filtros.telefone} 
            onChange={(e) => onFiltroChange('telefone', e.target.value)} 
            placeholder="Digite o telefone" 
          />
        </div>
        <div className="form-group">
          <label>Vínculo</label>
          <input 
            type="text" 
            className="form-control" 
            value={filtros.vinculo} 
            onChange={(e) => onFiltroChange('vinculo', e.target.value)} 
            placeholder="Digite o vínculo" 
          />
        </div>
        <div className="form-group">
          <label>Status</label>
          <select 
            className="form-control" 
            value={filtros.status} 
            onChange={(e) => onFiltroChange('status', e.target.value)}
          >
            <option value="ATIVOS">Ativos</option>
            <option value="INATIVOS">Inativos</option>
            <option value="TODOS">Todos</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default FiltrosPessoas;